import {  IQuanLyDangKyActionTypes } from "../../action-types/quan-ly-dang-ky/IQuanLyDangKyActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IQuanLyDangKyReducer } from "../../reducer-model/quan-ly-dang-ky/IQuanLyDangKyReducer";

const iniState: IQuanLyDangKyReducer = {
    selectedTab: "mo-dot",
    statusLopTinChi: eReducerStatusBase.is_not_initialization,
    lopTinChis: [],
    selectedQuyDinhId: 0,
}
export const quanLyDangKyReducer = (state: IQuanLyDangKyReducer = iniState, action: IQuanLyDangKyActionTypes): IQuanLyDangKyReducer => {
    switch (action.type) {
        case "QUAN_LY_DANG_KY_CHANGE_SELECTED_TAB":
            return {
                ...state,
                selectedTab: action.payload,
            }
            case "QUAN_LY_DANG_KY_LOAD_LOP_TIN_CHI_START":
                return {
                    ...state,
                    statusLopTinChi: eReducerStatusBase.is_loading,
                };
            case "QUAN_LY_DANG_KY_LOAD_LOP_TIN_CHI_SUCCESS":
                return {
                    ...state,
                    statusLopTinChi: eReducerStatusBase.is_completed,
                    lopTinChis: action.payload,
                };
            case "QUAN_LY_DANG_KY_LOAD_LOP_TIN_CHI_ERROR":
                return {
                    ...state,
                    statusLopTinChi: eReducerStatusBase.is_completed,
                };
            case "QUAN_LY_DANG_KY_CHANGE_SELECTED_QUY_DINH_ID":
                return {
                    ...state,
                    selectedQuyDinhId: action.payload,
                };
        default:
            return state;
    }
}